import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import ExperiencesModal from '@/components/modal/components/experiences-modal/experiences-modal';
import { ExperienceType } from '@/generated/graphql';

const MainDiv = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  justify-content: space-between;
`;
const Experience = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0;
`;
const IconDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const Icon = styled.img`
  width: 65px;
  height: 65px;
  object-fit: cover;
`;
const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 32px;
  width: 70%;
`;
const Heading = styled(Typography)`
  font-family: var(--font-work-sans);
  font-weight: 600;
  font-size: 20px;
  line-height: 136.8%;
  color: ${({ theme }) => theme.palette.common.midnight};
  margin-top: 5px;
`;
const Detail = styled(Typography)`
  font-family: var(--font-work-sans);
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 159.3%;
  color: ${({ theme }) => theme.palette.common.midnight};
`;
const Link = styled(Typography)`
  font-family: var(--font-cooper-light);
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 159.3%;
  color: #4d66b1;
`;
const MobileView = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [experience, setExperience] = useState<Exclude<ExperienceType, ExperienceType.Undefined>>();
  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);
  return (
    <MainDiv>
      <Experience>
        <IconDiv>
          <Icon src={'/discover/experiences/mobile/video.png'} alt={'videoIcon'} />
        </IconDiv>
        <TextDiv>
          <Heading>Video experiences</Heading>
          <Detail>Watch a video and try an experience at home.</Detail>
          <Link
            onClick={() => {
              // closeModal();
              setOpen(!open);
              setExperience(ExperienceType.Video);
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Experience>
      {/*<Experience>
        <IconDiv>
          <Icon src={'/discover/experiences/mobile/box.png'} alt={'video-experience'} />
        </IconDiv>
        <TextDiv>
          <Heading>Box experiences</Heading>
          <Detail>All-inclusive box experiences delivered to your doorstep.</Detail>
          <Link
            onClick={() => {
              // closeModal();
              setOpen(!open);
              setExperience(ExperienceType.Box);
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Experience>*/}
      <Experience>
        <IconDiv>
          <Icon src={'/discover/experiences/mobile/one-on-one.png'} alt={'box-experience'} />
        </IconDiv>
        <TextDiv>
          <Heading>One-on-one experiences</Heading>
          <Detail>
            Meet with one of our hosts in-person or online to try an experience together.
          </Detail>
          <Link
            onClick={() => {
              // closeModal();
              setOpen(!open);
              setExperience(ExperienceType.Schedule);
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Experience>
      <Experience>
        <IconDiv>
          <Icon src={'/discover/experiences/mobile/group.png'} alt={'videoIcon'} />
        </IconDiv>
        <TextDiv>
          <Heading>Group experiences</Heading>
          <Detail>
            Participate in an in-person or online group experience to meet people from your
            community.
          </Detail>
          <Link
            onClick={() => {
              // closeModal();
              setOpen(!open);
              setExperience(ExperienceType.Event);
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Experience>
      <ExperiencesModal open={open} onClose={closeModal} type={experience} />
    </MainDiv>
  );
};

export default MobileView;
